import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import TrashBind from "@/assets/icon/svgs/TrashBind.svg?react";

export function PopUpConfirmDelete({
  trigger,
  onConfirm,
}: {
  trigger: React.ReactNode;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDialogClose = (isOpen: boolean) => {
    setIsOpen(isOpen);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDialogClose} modal={false}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>

      {isOpen && (
        <div className="fixed inset-0 bg-black/10 backdrop-blur-[4px] z-40 pointer-events-none"></div>
      )}
      <DialogContent
        className="max-h-full overflow-auto gap-4 pb-[40px]"
        onInteractOutside={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader className="mb-[16px]">
          <DialogTitle className="flex flex-col gap-6 items-center font-medium">
            <span className="text-[#FF0000]">
              <TrashBind width={48} height={48} />
            </span>

            <div className="flex-1 flex flex-col gap-4 justify-center items-center">
              <span className="text-[24px] leading-[32px] whitespace-pre-line">
                {t("popUpConfirmDelete.title")}
              </span>
              <span className="text-[18px] leading-[24px] text-[#00000080] whitespace-pre-line">
                {t("popUpConfirmDelete.description")}
              </span>
            </div>
            <div className="flex flex-row gap-4">
              <Button
                variant="outline"
                className="w-fit h-[60px] text-[24px]"
                onClick={() => setIsOpen(false)}
              >
                {t("popUpConfirmDelete.cancel")}
              </Button>
              <Button
                type="submit"
                variant="system"
                size="system"
                className="w-fit px-4 "
                onClick={onConfirm}
              >
                {t("popUpConfirmDelete.confirm_deletion")}
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
